import AMap from 'AMap'
import { getAreaCode } from 'utils/baseMethods'
/**
 * @description 获取地区定位 缓存时间
 */
const MAXIMUMAGE  = 18000
const state = {
  province:'正在定位',
  city:'',
  provinceCode:'',
  cityCode:'',
  area:[
    
  ]
}

const mutations = {
  setLocationData(state,payload) {
    state.province = payload.province
    state.city = payload.city,
    state.provinceCode = payload.provinceCode
    state.cityCode = payload.cityCode
    state.area = []
    state.area.push({code:payload.cityCode,name:payload.city})
    state.area.push({code:payload.provinceCode,name:payload.province})
  }
}

const actions = {
  getLocation({ commit,state }) {
    // 由于只获取省市 所以判断 如果有上一次得缓存信息 那么就不获取
    if (state.area.length !== 0 ) return
    AMap.plugin('AMap.Geolocation', function () {
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：5s
        timeout: 5000,
        maximumAge:MAXIMUMAGE
      })
      geolocation.getCurrentPosition()
      AMap.event.addListener(geolocation, 'complete', onComplete);
      AMap.event.addListener(geolocation, 'error', onError);
      // data是具体的定位信息
      function onComplete(data) {
        console.log('具体的定位信息',data)
        if (data.info === 'SUCCESS') {
          let info = {
            ...data.addressComponent,
            cityCode:getAreaCode(data.addressComponent.province),
            provinceCode:getAreaCode(data.addressComponent.city,2)
          }
          commit('setLocationData',info)
        }
      
      }
      function onError(data) {
        console.log(data)
        // 失败 启用 ip定位
        AMap.plugin('AMap.CitySearch', function () {
          var citySearch = new AMap.CitySearch();
          citySearch.getLocalCity(function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                // 查询成功，result即为当前所在城市信息
              console.log('通过ip获取当前城市：', result)
              let info = {
                ... result,
                cityCode:getAreaCode(result.province),
                provinceCode:getAreaCode(result.city,2)
              }
              commit("setLocationData",info)
            }
          })
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}